<template>
    <v-dialog v-model="this.store.state.loading" fullscreen>
        <v-container
            fluid
            fill-height
            style="background-color: rgba(255, 255, 255, 0.5);"
        >
            <v-layout justify-center align-center>
                <v-progress-circular indeterminate color="primary">
                </v-progress-circular>
            </v-layout>
        </v-container>
    </v-dialog>
</template>

<script>
import store from '../../store'
export default {
    data:()=>({
        store:store,
    })
};
</script>

<style></style>
